import type { DispatchWithoutAction } from 'react';
import { useRef } from 'react';
import { v4 } from 'uuid';

export const useIK = () => {
  const ikValue = useRef<string>(v4());
  const cycleIK: DispatchWithoutAction = () => {
    ikValue.current = v4();
  };
  return { getIK: () => ikValue.current, cycleIK };
};
